import React, { useEffect } from 'react'
import ReactSelect, { components } from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'
import classNames from 'classnames'

const Option = props => {
    const dataProp = {
        innerProps: {
            'data-testid': props.data.value,
            ...props.innerProps,
        },
    }
    return <components.Option {...{ ...props, ...dataProp }} />
}

const Select = ({
    label,
    value,
    onChange,
    testId,
    testIdItems,
    testIdIndex,
    options,
    tooltip,
    ...props
}) => {
    useEffect(() => {
        if (testId !== undefined) {
            document
                .getElementsByClassName('peracto-select__control')[0]
                .setAttribute('data-testid', testId)

            const temp = document.getElementsByClassName('peracto-select__menu-list')
            if (temp.length > 0) {
                for (let index = 0; index < temp.length; index++) {
                    const t1 = temp[index]

                    if (testIdIndex >= 0) {
                        if (index === testIdIndex) {
                            let t2 = document.createAttribute('data-testid')
                            t2.value = testIdItems
                            t1.setAttributeNode(t2)
                        }
                    }

                    if (!testIdIndex) {
                        let t2 = document.createAttribute('data-testid')
                        t2.value = testIdItems
                        t1.setAttributeNode(t2)
                    }
                }
            }
        }
    }, [testId, testIdIndex, testIdItems])

    return (
        <div
            className="form-group"
            data-testid={`${label.toLowerCase().replaceAll(' ', '-')}-section`}
        >
            <div {...props}>
                {label && <label className="!mb-1">{label}</label>}
                {tooltip && (
                    <span
                        data-tooltip={tooltip}
                        className={classNames('!ml-2', {
                            'tooltip-wrap': tooltip.length > 50,
                        })}
                    >
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </span>
                )}
            </div>

            <ReactSelect
                components={{ Option }}
                value={options.find(opt => opt.value === value) || null}
                onChange={onChange}
                options={options}
                classNamePrefix="peracto-select"
                data-testid={testId}
            />
        </div>
    )
}

export default Select
